import React from 'react';
import { createPortal } from 'react-dom';

const FdoPopup = ({ fdoPopup, onClose, onConfirm }) => {
    if (!fdoPopup) return null;

    const Modal = ({ children, onClose }) => {
        const handleClickInside = (e) => e.stopPropagation();

        return createPortal(
            <div className="filter-overlay" onClick={onClose}>
                <div className="filter-dropdown-modal" onClick={handleClickInside}>
                    {children}
                </div>
            </div>,
            document.body
        );
    };

    return (
        <Modal onClose={onClose}>
            <div style={{ padding: '24px', maxWidth: '500px' }}>
                <div 
                    dangerouslySetInnerHTML={{ __html: fdoPopup?.pack?.popUpScript }} 
                    style={{ marginBottom: '24px', lineHeight: '1.6' }} 
                />
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                    {/* <button
                        onClick={onClose}
                        style={{
                            padding: '10px 24px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            background: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        No
                    </button> */}
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: '10px 24px',
                            borderRadius: '6px',
                            border: 'none',
                            background: '#D02F92',
                            color: '#fff',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        {fdoPopup?.pack?.popUpButtonName || "Ok"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default FdoPopup;
